export const DEALER_USER = "Dealer-User"
export const ASSOCIATE_USER = "Associates"
export const NON_ASSOCIATE_USER = "Non-Associates"